import { NetworkError } from '../types/errors';

export function createNetworkError(error: any): NetworkError {
  if (error.code === 'ECONNABORTED') {
    return {
      code: 'REQUEST_TIMEOUT',
      message: 'The request timed out. Please try again.',
      severity: 'error',
      retryable: true,
      suggestion: 'Check your internet connection and try again.',
    };
  }

  if (!error.response) {
    return {
      code: 'NETWORK_ERROR',
      message: 'Unable to connect to the server.',
      severity: 'error',
      retryable: true,
      suggestion: 'Please check your internet connection.',
    };
  }

  const status = error.response.status;
  switch (status) {
    case 400:
      return {
        code: 'BAD_REQUEST',
        message: 'The request was invalid.',
        severity: 'error',
        status,
        retryable: false,
        suggestion: 'Please check your input and try again.',
        details: {
          type: error.response.data?.error,
          model_name: error.response.data?.model_name,
          requested_lat: error.response.data?.requested_lat,
          requested_lon: error.response.data?.requested_lon,
        },
      };
    case 401:
      return {
        code: 'UNAUTHORIZED',
        message: 'Authentication required.',
        severity: 'error',
        status,
        retryable: false,
        suggestion: 'Please log in again to continue.',
      };
    case 403:
      return {
        code: 'FORBIDDEN',
        message: "You don't have permission to access this resource.",
        severity: 'error',
        status,
        retryable: false,
        suggestion: 'Contact support if you need access.',
      };
    case 404:
      return {
        code: 'NOT_FOUND',
        message: 'The requested resource was not found.',
        severity: 'error',
        status,
        retryable: false,
        suggestion: 'Please check the request parameters.',
      };
    case 429:
      return {
        code: 'RATE_LIMITED',
        message: 'Too many requests. Please wait before trying again.',
        severity: 'warning',
        status,
        retryable: true,
        suggestion: 'Try again in a few minutes.',
      };
    case 500:
      return {
        code: 'SERVER_ERROR',
        message: 'An unexpected server error occurred.',
        severity: 'error',
        status,
        retryable: true,
        suggestion: 'Please try again later.',
      };
    default:
      return {
        code: 'UNKNOWN_ERROR',
        message: 'An unexpected error occurred.',
        severity: 'error',
        status,
        retryable: true,
        suggestion: 'Please try again or contact support if the issue persists.',
      };
  }
}
